var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlanePack = function SvgPlanePack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E1E1E",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M8.46 18.753a1.38 1.38 0 0 1-1.379-1.38v-5.287h-2.85l-1.137 2a.988.988 0 0 1-1.846-.488V6.408a.987.987 0 0 1 1.846-.488l1.137 2h2.85V2.632a1.375 1.375 0 0 1 2.605-.625l3.004 5.912h3.975a2.084 2.084 0 0 1 0 4.167H12.69l-3.004 5.913a1.38 1.38 0 0 1-1.225.754"
  })));
};
export default SvgPlanePack;